module.exports = __webpack_public_path__ + "img/report3-5.b18ef9a4.png";